import React from 'react';

import { Button, Modal, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { BookingWaiter, changeActiveBookingsWaitId, selectBookingsWait } from 'features/bookingWait';
import { changeActiveModal } from 'features/modals';

interface Props {
  handleCancel: () => void;
}

export const BookingWaitListModal = ({ handleCancel }: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const waitingList = useAppSelector(selectBookingsWait);

  if (waitingList === null) {
    return;
  }

  const handleEditWaiter = (ids: number[]) => {
    dispatch(changeActiveModal('edit-booking-wait-modal'));
    dispatch(changeActiveBookingsWaitId(ids));
  };

  const handleCreateWaitingList = () => {
    dispatch(changeActiveModal('create-booking-wait-modal'));
  };

  const modalTittle = t('booking-wait.title.list');
  return (
    <Modal
      title={modalTittle}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={false}
    >
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: 'flex',
        }}
      >
        {
          waitingList.map((waitInfo) => (
            <BookingWaiter waiterInfo={waitInfo} editWaiting={handleEditWaiter} key={waitInfo.id} />
          ))
        }
      </Space>
      <hr style={{ margin: '12px 0px', borderTopColor: 'rgba(0, 0, 0, 0.05)' }} />
      <Button onClick={handleCreateWaitingList} type='primary'>
        {t('booking-wait.button.create')}
      </Button>
    </Modal >
  );
};
